module.exports = __webpack_public_path__ + "img/foursome-cocoyoc.fee92d89.jpg";